"use strict";

// scss requires
require("./_styles.scss");
// dependencies
var React = require("react/addons");
var createReactClass = require("create-react-class");
var classnames = require("_lib/utils/classnames").default;
var _ = require("underscore");
var TouchMixin = require("_lib/ui/mixins/TouchMixin.jsx");

var ListDialogItem = createReactClass({
  mixins: [TouchMixin],

  /* lifecycle methods */
  getInitialState: function () {
    return {};
  },
  //componentWillUpdate: function() {
  //	this._unregisterBackboneEvents();
  //},
  //componentDidUpdate: function() {
  //	this._registerBackboneEvents();
  //},

  /* publics */
  close: function (e) {
    this.props.close();
  },

  /* privates */
  _handleClick: function (e) {
    this.props.onClick(this.props.data);
  },

  _handleClickWithTouch: function (e) {
    this._endTouch(this._handleClick, e);
  },

  /* render */
  render: function () {
    /* jshint ignore:start */

    const icon = this.props.icon;

    var filtered = this.props.data.attributes.filtered;

    var classes = classnames({
      ListItem: true,
      //'selected': this.props.selected,
      //'on': !filtered
    });

    var displayContainer = !_.isFunction(this.props.display)
      ? this.props.data.attributes[this.props.display]
      : this.props.display(this.props.data);

    return (
      <div
        className={classes}
        onClick={this.touchProxy.bind(this, this._handleClick, [])}
        onTouchStart={this._startTouch}
        onTouchMove={this._moveTouch}
        onTouchEnd={this.touchProxy.bind(this, this._handleClickWithTouch, [])}
      >
        <span className={this.props.selected ? "text selected" : "text"}>
          {displayContainer} {icon}
        </span>
      </div>
    );
  },
});

module.exports = ListDialogItem;
